import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import * as style from './Text.st.css';
import { StylableDOMUtil } from '@stylable/dom-test-kit';

export interface TextDriver extends BaseUniDriver {
  getAttribute(attrName: string): Promise<string | null>;
  /** Per a11y definitions, for text elements, aria-label should not be used with the text content but rather use a solution as described here: https://accessible360.com/accessible360-blog/use-aria-label-screen-reader-text/ */
  isAriaLabelElementExists(): Promise<boolean>;
  /** The content of the SR only element containing the aria-label information */
  getAriaLabelContent(): Promise<string>;
  getTagName(): Promise<string>;
  getLang(): Promise<string>;
  getContent(): Promise<string>;
  getTypography(): Promise<string | boolean>;
  getPriority(): Promise<string | boolean>;
  isMobile(): Promise<boolean>;
}

export const textDriverFactory = (base: UniDriver): TextDriver => {
  const stylableDOMUtil = new StylableDOMUtil(style);
  return {
    ...baseUniDriverFactory(base),
    getAttribute: async (attrName) => base.attr(attrName),
    isAriaLabelElementExists: async () => {
      throw new Error(
        'Impossible to implement with unidriver, please remove the test',
      );
    },
    getAriaLabelContent: async () => {
      throw new Error(
        'Impossible to implement with unidriver, please remove the test',
      );
    },
    getTagName: async () => (await base.getNative()).tagName.toLowerCase(),
    getContent: async () => base.text(),
    getLang: async () => base.attr('lang'),
    getTypography: async () => {
      const element = await base.getNative();
      return stylableDOMUtil.getStyleState(element, 'typography');
    },
    getPriority: async () => {
      const element = await base.getNative();
      return stylableDOMUtil.getStyleState(element, 'priority');
    },
    isMobile: async () => !!(await base.attr('data-mobile')),
  };
};
